// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","shadow":"Button_shadow__pa8Ob","edge":"Button_edge__Ue2my","front":"Button_front__8pYXH","refresh":"Button_refresh__Pl62q"};